import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import {
  fetchRepairReasons,
  fetchRepairReasonsSelect,
  fetchRepairReasonsInProgress
} from "../../ducks/redux/actions/dashboardReducer.actions";
import RepairReason from "../RepairReason/index";
import "./styles.css";
import { isNullOrUndefined } from "../../utils/formatting";
import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { CurrentRepair } from "../../models/Repair/Repair";
import { PremisesTypeId } from "../../models/Customer/Premises";
import Address from "../../models/Customer/Address";
import CustomerName from "../../models/Customer/CustomerName";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";

import {
  getContractorName,
  workOrderRepairObject,
} from "../../ducks/redux/actions/getAddress";
import {
  userChosenSupplementaryQuestions,
  userChosenDuplicateQuestion,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  resumeDraftRepair,
  backToRepairAsset,
  workOrderData,
  userChosenSaveExit,
  userChosenNotifyAll,
  userChosenEmergencyQuestion,
  dmcCheckSavedAnswer,
  isSaveAndExitAllowed
} from "../../ducks/redux/actions/userChoices";
import { RepairPriority } from "../../models/Repair/CreateRepair";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { saveActivePopHazardCaseFlag } from "../../ducks/redux/actions/hazardAssessment";

interface RepairDetailsProps extends RouteComponentProps<any> { }

const RepairDetails: React.FC<RepairDetailsProps> = (props) => {
  const dispatch = useDispatch();

  //To track radio button selection for RepairProperty--Start here---

  //-----------Ends here-----------//
  enum RepairReportingMethods {
    "Telephone" = 1,
    "Email" = 2,
    "Social media" = 3,
    "Customer Self-Serve" = 4,
    "Colleague Self-Serve" = 5,
  }
  const [selectedreportingMethod] = useState(
    "Colleague Self-Serve"
  );
  const { t } = useTranslation();

  const [isDisabledOrbis, setisDisabledOrbis] = useState(false);
  const [isDisabled, setisDisabled] = useState(false);
  const [isRepairReasonLoading, setIsRepairReasonLoading] = useState(true);
  const repairReasonLoadingRef = React.useRef(true);
  const handleRepairReasonLoadingChange = (loading: boolean) => {
    repairReasonLoadingRef.current = loading;
    setIsRepairReasonLoading(loading);
  };
  const [chosenHL, setChosenHL] = useState("");
  const [locatioAlert, setLocatioAlert] = useState<string[]>([]);
  const closeAfterSaving= false;

  let alertMstArray: any[] = [];
  const addresses = useSelector(
    (state: any) => state.addresses?.customerassociatedassets
  );

  const fetchedRepairReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.fetchedRepairReasons
  );
  const userTypedRepairReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.userTypedRepairReasons
  );
  const IsRecall = useSelector(
    (state: any) => state.userChoicesReducer?.IsRecall
  );

  const userChosenRepairLocationId = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenRepairLocationId
  );
  const userChosenHighLevelDescriptionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription
  );

  const userChosenSORValue = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSOR
  );

  const userChosenRepairLocation = useSelector(
    (state: any) => state.userChoicesReducer.userChosenRepairLocation);

  const selectedRepairReasonObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject
  );

  const assetDetails = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject
  );
//active pop case flag
  const activePopHazardCaseFlag = useSelector(
    (state: any) => state?.hazard?.activePopHazardCaseFlag
  );

  const tenanciesData = useSelector(
    (state: any) => state.addresses.customertenancies
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );

  const priority = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState
        ?.selectedRepairReasonPriorityOverride ??
      state?.dashboardReducer?.formState?.selectedRepairReasonObject?.[0]
        ?.priority
  );

  const selectSorValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenSOR
  );
  
  const saveAndExit = !(isNullOrUndefined(userChosenRepairLocation) && isNullOrUndefined(userChosenSORValue));//if no repair location and no SOR value then save and exit is disabled

  const customerID = useSelector((state: any) => state.addresses?.customerid);

  const resumeDraftRepairVal = useSelector(
    (state: any) => state.userChoicesReducer.resumeDraftRepair
  );
  const userResumeDraftDataCache = useSelector(
    (state: any) => state.userChoicesReducer.userResumeDraftDataCache
  );

  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );

  const loadDuplicateRepairPageValue = useSelector(
    (state: any) => state.userChoicesReducer.loadDuplicateRepairPage
  );
  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystProperty
  );

  const priorityCodeValue = useSelector(
    (state: any) => state.dashboardReducer.formState?.priorityCode
  );

 const caseIdentifier = useSelector((state: any) => state.hazard?.activeHazardCaseDetails);
 
  const workOrderRepair = new CurrentRepair();
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
  }
  const _premisesTypeId: any =
    PremisesTypeId[assetDetails?.assetType as keyof typeof PremisesTypeId];
  workOrderRepair.repairReason = selectedRepairReasonObject?.[0]?.description ?? userChosenHighLevelDescriptionBackButton
  workOrderRepair.description = selectedRepairReasonObject?.[0]?.description ?? userChosenHighLevelDescriptionBackButton
  workOrderRepair.premisesId = assetDetails?.id;
  if (assetDetails?.assetType === "Divided Block") {
    workOrderRepair.premisesTypeId = "5";
  } else {
    workOrderRepair.premisesTypeId = _premisesTypeId;
  }
  workOrderRepair.customerIdentifier = customerID;

  workOrderRepair.isEmergency = priority == RepairPriority.Emergency
  workOrderRepair.premisesUniqueReference = assetDetails?.uprn;
  const _address = new Address();
  _address.addressLine1 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine1;
  _address.addressLine2 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine2;
  _address.addressLine3 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine3;
  workOrderRepair.premisesAddress = _address;
  workOrderRepair.sorCode =
    selectSorValue?.length > 0
      ? selectSorValue
      : selectedRepairReasonObject?.[0]?.sors[0]?.sorCode;

  workOrderRepair.customerName = new CustomerName({
    title: customerDetails?.person?.name?.title,
    givenName: customerDetails?.person?.name?.givenName,
    surname: customerDetails?.person?.name?.surname,
  });
  workOrderRepair.reportingMethodId =
    RepairReportingMethods[
    selectedreportingMethod as keyof typeof RepairReportingMethods
    ];
  workOrderRepair.reportingMethod = selectedreportingMethod;

  workOrderRepair.notifyAll = false;
  workOrderRepair.eTag = customerDetails?.eTag; // Need to verify
  workOrderRepair.eligibilityOutcomes = [];
  workOrderRepair.assetIdentifier = tenanciesData?.premisesIds;
  workOrderRepair.repairLocationId = userChosenRepairLocationId;
  workOrderRepair.repairCause = "General Wear and Tear";
  workOrderRepair.isCatalyst = isCatalyst;
  workOrderRepair.priority = priorityCodeValue;

  workOrderRepair.repairCauseId =
    RepairCauseId[workOrderRepair.repairCause as keyof typeof RepairCauseId];
  const _worksOrderRequest = new WorksOrderRequest(workOrderRepair);
  const woRequestParameters =
    _worksOrderRequest.createWorkOrderParameter(workOrderRepair);

  const CreateWorkOrder = async (result: boolean) => {
    try {
      woRequestParameters.isEmergency = priority == RepairPriority.Emergency;
      woRequestParameters.isDraft = true;
      woRequestParameters.priority = priorityCodeValue;

      if (caseIdentifier) {
        woRequestParameters.caseIdentifier = caseIdentifier?.identifiers?.caseIdentifier;
        workOrderRepair.caseIdentifier = caseIdentifier?.identifiers?.caseIdentifier;

        const hazardSorCode = selectedRepairReasonObject?.[0]?.hazardSorCode ?? "";
        woRequestParameters.hazardSorCode = hazardSorCode;
        workOrderRepair.hazardSorCode = hazardSorCode;
      }

      if (!chosenHL) {
        woRequestParameters.repairReason = "";
        woRequestParameters.description = "";
      }

      woRequestParameters.isInDefect = assetDetails?.statuses.isInDefects;
      const apiResponse = await api.createWorkOrderRepair({
        ...woRequestParameters,
      });

      if (selectSorValue?.length > 0) {
        workOrderRepair.sorCode = selectSorValue;
      }

      if (apiResponse?.location.length > 0) {
        const workorderLocation = apiResponse?.location.split("/");
        workOrderRepair.id = workorderLocation[4];
        workOrderRepair.worksOrderIdentifier = workorderLocation[4];
        dispatch(workOrderRepairObject(workOrderRepair));
        const worksOrder = new WorksOrderRequest(workOrderRepair);
        dispatch(workOrderData(worksOrder));
        if (!result) {
          RedirectNextPage();
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      console.log("e")
    }
  };

  const updateWorkOrder = async (result: boolean) => {
    try {
      let isEnhancedDiagnosticsRepair: boolean = false;
      if (workOrderObject.isEnhancedDiagnosticsRepair) {
        isEnhancedDiagnosticsRepair = true;
        workOrderObject.elementCode = "";
        workOrderObject.isEnhancedDiagnosticsRepair = false;
        workOrderObject.workProgramme = "";
      }
      resumeDraftRepairValFunc();

      workOrderObject.sorCode =
        selectSorValue?.length > 0
          ? selectSorValue
          : selectedRepairReasonObject?.[0]?.sors[0]?.sorCode;
      const shouldPersistHazardSorCode =
        selectedRepairReasonObject?.[0]?.isPreAssessmentRequired !== true &&
        !workOrderObject.assessmentInformation?.identifier &&
        !workOrderObject.assessmentIdentifier;
      persistHazardSorCode(shouldPersistHazardSorCode);
      workOrderObject.repairReason = selectedRepairReasonObject?.[0]?.description;
      workOrderObject.description = selectedRepairReasonObject?.[0]?.description;
      workOrderObject.repairLocationId = userChosenRepairLocationId;
      if ((!workOrderObject.assessmentInformation?.identifier && !workOrderObject.assessmentIdentifier) ||
        priorityCodeValue !== workOrderObject.priorityCode) {
        workOrderObject.isEmergency = priority === RepairPriority.Emergency;
      }
      workOrderObject.priority = priorityCodeValue;

      const hasExplicitCaseIdentifier = caseIdentifier !== undefined;
      const resolvedCaseIdentifier = hasExplicitCaseIdentifier
        ? caseIdentifier?.identifiers?.caseIdentifier ?? ""
        : workOrderObject?.caseIdentifier?.identifiers?.caseIdentifier || "";
      workOrderObject.caseIdentifier = resolvedCaseIdentifier;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject, isEnhancedDiagnosticsRepair);
      (woRequestParameters as any).caseIdentifier = resolvedCaseIdentifier;
      if (resolvedCaseIdentifier || shouldPersistHazardSorCode ||
        workOrderObject.assessmentInformation?.identifier || workOrderObject.assessmentIdentifier) {
        (woRequestParameters as any).hazardSorCode = workOrderObject.hazardSorCode;
      } else {
        delete (woRequestParameters as any).hazardSorCode;
      }

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );

      dispatch(workOrderRepairObject(workOrderObject));

      if (!result) {
        RedirectNextPage();
      }
    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    }
  };

  const persistHazardSorCode = (shouldPersistHazardSorCode:any) => {
      if (shouldPersistHazardSorCode) {
        workOrderObject.hazardSorCode = selectedRepairReasonObject?.[0]?.hazardSorCode ?? "";
      }
  }
  useEffect(() => {
    window.scrollTo(0, 0);

    (async function () {
      try {
        const premiseType =
          assetDetails?.assetType === "Block" ||
            assetDetails?.assetType === "Estate" ||
            assetDetails?.assetType === "Divided Block" ||
            assetDetails?.assetType === "Divided block" ||
            assetDetails?.assetType === "Estate Area"
            ? "Communal"
            : assetDetails?.assetType;

        if (
          userTypedRepairReasons != null &&
          userTypedRepairReasons.length > 0
        ) {
          dispatch(fetchRepairReasonsInProgress(true));
          const responsedata = await api.searchRepairReasons(
            userTypedRepairReasons,
            premiseType,
            isCatalyst
          );

          dispatch(fetchRepairReasonsSelect(responsedata));

          const extractedReasons: string[] = [];

          responsedata.forEach((eachData, key) => {
            const { description } = eachData;
            extractedReasons.push(description);
          });

          dispatch(fetchRepairReasons(extractedReasons));
          dispatch(fetchRepairReasonsInProgress(false));
        }
      } catch (e) {
        console.error(e);
        props.history.push("/GenericError");
      }
    })();
  }, [addresses, userTypedRepairReasons]);

  useEffect(() => {
    // Dispatching if continue button is disabled
    if (isDisabledOrbis || isDisabled || isRepairReasonLoading) {
      dispatch(isSaveAndExitAllowed(true));
    } else {
      dispatch(isSaveAndExitAllowed(false));
    }
  }, [isDisabledOrbis, isDisabled, isRepairReasonLoading]);


  useEffect(() => {
    alertMstArray = [];
    setLocatioAlert([]);
    if (userChosenRepairLocationId && userChosenHighLevelDescriptionBackButton) {
      setisDisabled(false);
    }
  }, [userChosenRepairLocationId]);

  const exitButtonHandler = () => {
    dispatch(backToRepairAsset(false));
    props.history.push("/LandingView");
  };

  const saveDraftAndExit = (e: any) => {
    dispatch(userChosenSaveExit(true));
    dispatch(backToRepairAsset(false));
    (workOrderObject == null
      ? CreateWorkOrder(true)
      : updateWorkOrder(true)
    ).then(() =>
      props.history.push(
        `/WorkOrder360View/${_worksOrderRequest?.identifiers?.worksOrderIdentifier
          ? _worksOrderRequest?.identifiers?.worksOrderIdentifier
          : workOrderRepair.worksOrderIdentifier
        }`
      )
    );
    setTimeout(() => {
      dispatch(userChosenSaveExit(false));
    }, 6000);
  };

  const getMandatoryData = (data: any) => {
    setChosenHL(data);
  };

  const resumeDraftRepairValFunc = () => {
    const repairLocationId = (userResumeDraftDataCache?.repairLocationId),
      repairReason = userResumeDraftDataCache?.repairReason;

    if (resumeDraftRepairVal) {
      //dispatch active pop case flag
      dispatch(saveActivePopHazardCaseFlag(activePopHazardCaseFlag));
      if (
        userChosenRepairLocationId !== repairLocationId ||
        chosenHL !== repairReason
      ) {
        dispatch(userChosenNotifyAll(null));
        dispatch(resumeDraftRepair(false));
        dispatch(userChosenSupplementaryQuestions(""));
        dispatch(dmcCheckSavedAnswer(""))
        dispatch(userChosenDuplicateQuestion(""));
        if (!IsRecall) {
          dispatch(userChosenVandalismQuestion("No"));
          dispatch(userChosenVandalismAdditionalInformation(""));
        }
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityQuestion("No"));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenEmergencyQuestion(""));
      }
    }
  }

  const callPageHandler = async () => {
    if (repairReasonLoadingRef.current) {
      return;
    }
    setisDisabled(true);
    dispatch(getContractorName(null));

    resumeDraftRepairValFunc();

    if (!chosenHL) {
      alertMstArray.push(t("CPR008"));
      setLocatioAlert(alertMstArray);
      return;
    } else if (
      userChosenRepairLocationId == 0 ||
      userChosenRepairLocationId === "No option selected"
    ) {
      alertMstArray.push(t("CPR007"));
      setLocatioAlert(alertMstArray);
      return;
    }

    alertMstArray = [];
    setLocatioAlert([]);

    if (!resumeDraftRepairVal && !loadDuplicateRepairPageValue) {
      if (isUndefinedNullOrEmpty(workOrderObject)) {
        await CreateWorkOrder(false);
      } else {
        await updateWorkOrder(false);
      }
    } else {
      await updateWorkOrder(false);
    }
  };

  const RedirectNextPage = () => {
    props.history.push("/SupplementaryQuestion");
  }

  return (
    <>
      <div
        className="ml-sm-5 pl-sm-5 pt-2 repair-text container"
        id="repreason-main-div"
      >
        <RepairReason
          suggestions={fetchedRepairReasons}
          setisDisabledOrbis={setisDisabledOrbis}
          setisDisabled={setisDisabled}
          onRepairReasonLoadingChange={handleRepairReasonLoadingChange}
          locatioAlert={locatioAlert}
          getMandatoryData={getMandatoryData}
          {...props}
        />
      </div>

      <div
        className="flex justify-between items-center pb-4 md:pb-8 container"
        id="repreason-main-btn"
      >
        <ExitModalAndSave
          id="repreason-exitmodal"
          exit={exitButtonHandler}
          saveDraftAndExit={saveDraftAndExit}
          closeAfterSaving={closeAfterSaving}
          canSaveAndExit={saveAndExit}
        />
        <Button
          id="btn_repairreason"
          type="button"
          data-testid="btncontinue"
          name="btncontinue"
          disabled={isDisabled || isDisabledOrbis || isRepairReasonLoading}
          onClick={callPageHandler}
          placeholder="btncontinue"
          value="Continue"
          className="button-class"
        >
          {t("continuen_button")}
          <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
        </Button>
      </div>
    </>
  );
};
export default RepairDetails;
